"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [Number, String],
        default: undefined
    },
    culture: {
        type: String,
        default: undefined
    },
    decimals: {
        type: Number,
        default: undefined
    },
    downArrowText: {
        type: String,
        default: undefined
    },
    factor: {
        type: Number,
        default: undefined
    },
    format: {
        type: String,
        default: undefined
    },
    max: {
        type: Number,
        default: undefined
    },
    min: {
        type: Number,
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },
    restrictDecimals: {
        type: Boolean,
        default: undefined
    },
    round: {
        type: Boolean,
        default: undefined
    },
    spinners: {
        type: Boolean,
        default: undefined
    },
    step: {
        type: Number,
        default: undefined
    },
    upArrowText: {
        type: String,
        default: undefined
    },
    value: {
        type: [Number, String],
        default: undefined
    },

    // Events
    change: Function,
    spin: Function
};